import 'trackjs'
import './App.css'
import './ravenStyles.css'
import { ThemeProvider as RuiThemeProvider } from '@atd/rui-base.theme.theme-provider'
import { ravenThemeV5 } from './ravenV5Theme'
import { Provider } from 'react-redux'
import React from 'react'
import { createRoot } from 'react-dom/client'
import store, {persistor} from './store'
import { unregister } from './registerServiceWorker'
import App from './App'
import ErrorBoundary from './commonComponents/errorBoundary'
import {PersistGate} from 'redux-persist/integration/react'

unregister()

const styles = {
    container: {
        paddingTop: 5,
        paddingLeft: 5,
        paddingRight: 5,
    },
}

const root = createRoot(document.getElementById('root'))
root.render(
    <ErrorBoundary>
        <RuiThemeProvider lightTheme={ravenThemeV5} initialMode="light">
            <PersistGate loading={null} persistor={persistor}>
                <Provider store={store} style={styles.container}>
                    <App/>
                </Provider>
            </PersistGate>
        </RuiThemeProvider>
    </ErrorBoundary>)
